// extracted by mini-css-extract-plugin
export default {"vertical-icon":"style_vertical-icon__dBo7h"};